<template>
  <div class="modal-conatiner">
    <div class="modal" ref="modal">
      <div class="modal-content">
        <div class="slider-group">
        <div class="carousel carousel-slider" ref="carousel">
          <transition-group >
            <div class="slider-item carousel-item" :data-id="i"  v-for="(slide, i) in slides" :key="slide.id">
              <div class="step-count" v-if="i >= 0">
                {{i + 1}}
              </div>
             
             

              <div class="row">
                <div class="col s12 no-padding">
                   <div class="modal-title" v-html="slide.title"></div>
                   <div class="modal-details " v-html="slide.message"></div>
                </div>
                
                <div class="col hide-on-med-and-down s12 m3 hide">

                  <div class="images col s12" v-for="image, v in slide.icon" :key="v+1*1.33">
                    <img :src="image" alt="" width="100%">
                </div>

                </div>

              </div>
              
            </div>
          </transition-group>
        </div>
        <div class="slider-navigation">
          <button @click="modal.instance.close()" v-if="activeIndex < 1" class="btn btn-rounded transparent grey-text text-darken-3 left">DISMISS</button>
          <button @click="sliderInstance.prev()" v-else class="btn btn-rounded transparent grey-text text-darken-3 left">BACK</button>
          <button @click="sliderInstance.next()" v-if="activeIndex < (slides.length - 1)" class="btn btn-rounded amber amber-darken-2 grey-text text-darken-3 right ">NEXT</button>
       <button @click="modal.instance.close()" v-else   class="btn btn-rounded amber amber-darken-2 grey-text text-darken-3 right ">BEGIN</button>
          <!-- <router-link @click="sliderInstance.next()" tag="button" :to="{path:'/account/home-profile'}" v-else class="btn btn-rounded amber amber-darken-2 grey-text text-darken-3 right ">HOME PROFILE</router-link> -->
          <div class="clear"></div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import energyIcon from '@/assets/energy_calculator.svg'
import realOverview from '@/assets/overview_image.svg'
import waterPpl from '@/assets/water_shortage.svg'
import homeImage from '@/assets/home_profile.svg'
import windHazard from '@/assets/wind-hazard@2x.png'
import floodHazard from '@/assets/flood-hazard@2x.png'
export default {
  name: 'AppGuide',
  props: {
    modalState:{
      type: String,
      default: 'close'
    },
  },
  data () {
    return {
      icons:{
          energyIcon,
          realOverview,
          waterPpl,
          homeImage,
          windHazard,
          floodHazard,
      },
      ready: false,
      slides:[
        {
          id: 1,
          title: 'Home Profile',
          message: 'Get started by entering basic information about your home and its location. Upload  photos to support your selections.',
          icon: [homeImage],
        },
        {
          id: 2,
          styles:{},
          title: 'Guided Assessments',
          message: /* html */`
         <p> Complete the guided assessments to estimate the potential impact wind, flooding and water shortage from a Category 5 hurricane could have on your home. </p>
          <p>Also, complete the Household Carbon Footprint Calculator to determine your home energy usage and associated carbon emissions.</p>
          <p>Do these assessments in any order you prefer or do a little of each at a time! Your entries are automatically saved you as you go along and you can log out and return at any time to complete the assessments.</p>
          `,
          icon: [windHazard, floodHazard,  waterPpl, energyIcon]
        },
        {
          id: 3,
          title: 'Assessment Summary',
          styles:{},
          icon:[realOverview],
          message: 'Review your assessment results and summarize which hazards pose the greatest risk to your home and why. Identify home improvement projects that would make your home more resilient. In addition, you can identify projects to lower your carbon footprint and energy bill.',
        }
      ],
      sliderInstance: null,
      slider_options: {
        fullWidth: true,
        indicators: true,
        onCycleTo: (e) => {
          this.activeIndex = parseInt(e.attributes['data-id'].value)
        }
      },
      activeIndex: 0,
      modal: {
        instance: null, 
        options: {
          endingTop:'0%',
          onOpenEnd: () => {
            this.ready = true
            this.$_initSlider()
          },
          onCloseStart: () => {
            setTimeout(() => {
               this.$emit('setState', 'closed')
            }, 300);
            
          },
          onCloseEnd: () => {
          setTimeout(() => {
            this.sliderInstance.destroy()
            this.modal.instance.destroy()
            this.sliderInstance = null
            this.modal.instance = null
          }, 150);
          }
        }
      }
    }
  },
  mounted () {
    this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options)
    setTimeout(() => {
      this.modal.instance.open()
    }, 150)
  },
  beforeDestroy (){
  this.modal.instance.close()
  this.modal.instance.destroy()
  },
  watch:{
    modalState: function (nV) {
      if(nV === 'open') {
        this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options)
        setTimeout(() => {
          this.modal.instance.open()
        }, 150);
      } 
      else if (nV === 'closed') {
       if ( this.modal.instance !== null ) {
        this.modal.instance.close()
       }
       if ( this.sliderInstance !== null ) {
         console.log('destroying')
        this.sliderInstance.destroy()
       }
     
      }
    }
  },
  methods: {
  $_initSlider () {
      this.sliderInstance = M.Carousel.init(
        this.$refs.carousel,
        this.slider_options
      )

    /*   setTimeout(() => {
        this.sliderInstance.destroy()
      }, 2000); */
    }
  }
}
</script>
<style scoped lang="scss">
.modal-conatiner {
  .modal {
    width: 95% !important;
    max-width: 768px;
    top: 56px !important;
    min-height: calc(100% - 128px) !important;
    /* background: #536dfe;
    color: white; */
    border-radius: 15px;
  }
  .modal-content {
    position: absolute;
    height: 100%;
    width: 100%;
    @media screen and (min-width:1025px) {
      padding: 36px;
    }
    .slider-group {
      position: relative;
      height: 100%;
      width: 100%;
    }
    .carousel {
      position: absolute;
      height: 100% !important;
      width: 100%;
      .carousel-item {
        padding:8px;
      }
      .carousel-slider {
        padding: 24px;
      }
    }
  }
  .modal-title {
    font-size: 36px;
    font-weight: 600;
    line-height: 42px;
    margin-bottom: 12px;
    @media screen and (max-width: 960px) {
        font-size: 24px;
        font-weight: 500;
        line-height: 36px;
    }
  }
  .modal-details {
    font-size: 16px;
    line-height: 1.6;
  @media screen and (min-width:1025px) {
     // font-size: 20px;
    }
  }
  .slider-navigation {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .step-count {
    background: #ffc107;
    display: inline-block;
    width: 36px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    border-radius: 4px;
    font-size: 18px;
    margin-left: 44px;
    margin-bottom: 14px;
    position: relative;
    color: #536dfe;
    font-weight: 600;
    &::before {
      content: ' ';
      position: absolute;
      left: 0px;
      top: 0px;
      background: #536dfe;
      width: 100%;
      height: 100%;
      z-index: -1;
      transform: rotate(-8deg);
      border-radius: 5px;
    }
    &::after {
        content: 'Step';
        position: absolute;
        left: -44px;
      //  color: white;
    }
  }
  .images {
   .card {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      .card-image {
        padding-top: 12px;
      }
    }
  }
}

</style>